<template>
  <div class="hero">
    <div class="wrap">
      <div class="content">
        <div class="inner1">
          <div class="inner-wrap">
            <img src="../assets/img/lobster-white.png" alt="J&C's Lobster Pot">
          </div>
        </div>
        <div class="inner2">
          <div class="tile tile1">
            <div class="default-button" role="button">
              <a href="https://jcslobsterpot.touchtakeaway.net" target="_blank">
                <div
                  class="button-inner"
                >Choose from set price lunch and dinner menus or our Catch of the day featuring freshly caught whole fish such as Dover or Lemon sole, Plaice, seabass, Bream and Skate or try our Bembridge lobster or Crab.</div>
              </a>
            </div>
          </div>
          <div class="tile tile2"></div>
        </div>
      </div>
      <div class="spacer">
        <video src="../assets/vid/shrimp.mp4" autoplay muted loop></video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Hero"
};
</script>

<style lang="scss" scoped>
.hero {
  position: relative;
  .wrap {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    height: 100%;
    min-height: 100vh;
    width: 100%;
    padding: 0;
    .spacer {
      display: block;
      width: 100%;
      height: 50vh;
      overflow: hidden;
      border-top: var(--border);
      order: 2;
      video {
        width: auto;
        height: auto;
        min-width: 100%;
        min-height: 100%;
        animation: revealInTop 0.8s ease 1.5s both;
        @media (max-width: 1024px) {
          max-height: 300px;
          min-height: auto;
          margin: 0 0 -5px 0;
          overflow: hidden;
        }
      }
      .image-holder {
        position: relative;
        height: 100%;
        width: 100%;
        overflow: hidden;
        &:after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          background-image: url("../assets/img/lob.jpg");
          background-size: cover;
          background-position: center;
          animation: revealInBottom 0.8s ease 1.5s both;
        }
      }
    }
    .content {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      height: 50vh;
      order: 1;
      overflow: hidden;
      @media (max-width: 1024px) {
        flex-direction: column;
      }
      .inner1 {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 50%;
        height: 100%;
        text-align: left;
        padding: 20px 40px;
        order: 1;
        background-color: var(--prim-c);
        animation: revealInBottom 0.8s ease 1s both;
        @media (max-width:1024px) {
          animation: revealInLeft 0.8s ease 1s both;
        }
        .inner-wrap {
          img {
            max-width: 100%;
          }
          .default-button {
            display: inline-block;
            width: auto;
            margin: 0 0 40px 0;
          }
          span {
            font-size: 22px;
            text-align: left;
            color: #fff;
          }
          h1 {
            position: relative;
            display: block;
            margin: 0 0 5px 0;
            color: #fff;
            &.large {
              font-size: 175px;
            }
          }
        }
      }
      .inner2 {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        height: 100%;
        width: 50%;
        text-align: left;
        order: 2;
        border: var(--border);
        border-left: unset;
        border-top: unset;
        border-bottom: unset;
        .tile {
          width: 100%;
          height: 50%;
        }
        .tile1 {
          order: 1;
          padding: 0px;
          background-color: #fff;
          overflow: hidden;
          .default-button {
            display: inline-block;
            width: fit-content;
            border: unset;
            height: 100%;
            width: 100%;
            margin: 0;
            animation: revealInLeft 0.5s ease-out 2s both;
            a {
              height: 100%;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              color: #000;
              transition-delay: 0s;
              .button-inner {
                padding: 50px;
                transition: 0.2s;
              }
            }
            &:hover {
              a {
                .button-inner {
                  transition-delay: 0s;
                  color: transparent;
                  transition: 0s;
                }
              }
            }
            &:before {
              content: "Order Now";
              position: absolute;
              top: 35%;
              left: 0;
              right: 0;
              color: #fff;
              font-size: 52px;
              font-weight: 600;
              text-align: center;
              opacity: 0;
              transition: opacity 0s ease;
            }
            &:hover:before {
              opacity: 1;
              transition: opacity 0.5s ease;
              transition-delay: 0.2s;
            }
          }
        }
        .tile2 {
          position: relative;
          height: 50%;
          width: 100%;
          overflow: hidden;
          &:after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-image: url("../assets/img/tile2.jpg");
            background-size: cover;
            background-position: center;
            animation: revealInTop 0.5s ease 2.25s both;
            @media (max-width:1024px) {
              animation: revealInRight 0.5s ease 2.25s both;
            }
          }
        }
      }
      .inner1,
      .inner2 {
        @media (max-width: 1024px) {
          width: 100%;
        }
      }
    }
    .content {
      @media (max-width: 1024px) {
        height: 100vh;
        overflow-y: visible;
      }
    }
    .spacer {
      @media (max-width: 1024px) {
        height: auto;
        order: 0;
        overflow: hidden;
      }
    }
  }
}
</style>

